<ion-header>
  <ion-toolbar color="medium">
    <ion-title style="color: white;">STT Inference Result</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="closeModal('close')">
        <ion-icon style="color: white;" name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" style="border: rgb(188, 183, 183) 2px solid;">
  <ion-card class="custom-card">

    <ion-card-content>
      <ion-label color="medium"><strong>Original Text</strong></ion-label>
      <p class="text-box">{{ data.originaltext }}</p>

      <ion-label color="medium"><strong>Transcribed Text</strong></ion-label>
      <p class="text-box modified-text">{{ data.transcribedtext }}</p>

      <p *ngIf="normalizeText(data.originaltext) !== normalizeText(data.transcribedtext)" class="warning-text" style="color: red;">
        The transcribed text does not match the original text.
      </p>
      <p *ngIf="normalizeText(data.originaltext) === normalizeText(data.transcribedtext)" class="warning-text" style="color: green;">
        The transcribed text matches the original text.
      </p>


      <ion-label color="medium"><strong>Audio URL</strong></ion-label>
      <!-- <p><a [href]="url" target="_blank" class="url-link">{{ url }}</a></p> -->

      <ion-row class="audio-container">
                <ion-col>
                  <audio controls class="audio-player" #audioPlayer>
                    <source [src]="data.audiopath" type="audio/mpeg" />
                    Your browser does not support the audio element.
                  </audio>
                </ion-col>
      </ion-row>

      <ion-item lines="inset">
        <ion-label position="stacked">Remarks</ion-label>
        <ion-input [(ngModel)]="remarks" placeholder="Enter remarks..." clearInput></ion-input>
      </ion-item>
    </ion-card-content>
  </ion-card>

  <div class="button-group">
    <ion-button expand="block" color="primary" (click)="saveRemarks()">
      <!-- <ion-icon name="save-outline" slot="start"></ion-icon> -->
      <ion-icon slot="start"></ion-icon>
      Add
    </ion-button>
    <!-- <ion-button expand="block" color="medium" (click)="closeModal('close')">
      <ion-icon name="close-circle-outline" slot="start"></ion-icon>
      Cancel
    </ion-button> -->
  </div>
</ion-content>
